import React from 'react';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import SEO from '../components/SEO';
import FooterSitemap from '../components/FooterSitemap';
import UseCasesPage from '../pages/useCasesPage';
import { useTranslation } from 'react-i18next';

export const UseCases = () => {
  const { t, i18n } = useTranslation();

  return (
    <Layout backgroundimage={Back1} actionDemo={false} footer={false}>
      <SEO
        title={t("Gestión de crédito automatizado")}
        description={t("Optimiza la aprobación de créditos. Registra más clientes, gestiona riesgos eficazmente y toma decisiones financieras inteligentes.")}
        works={[
          t("Digitalización de créditos"),
          t("Core Bancario"),
          t("Transformación financiera"),
          t("Innovación financiera"),
          t("Aprobación de Créditos"),
          t("Administración de cartera"),
          t("Administración de clientes"),
          t("Work flows"),
          t("Onboarding digital"),
          t("Emisión de tarjeta"),
          t("Dispersión de crédito"),
          t("Cobranza"),
          t("Campaña de notificaciones"),
          t("Mensajes automatizados"),
          t("Automatización de créditos"),
          t("Plataforma para gestión de créditos"),
          t("Software para Créditos")
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/credit-use-case' : 'caso-de-uso-credito'}`}
        hreflang={[
          { url: "https://dynamicore.io/caso-de-uso-credito", lang: "es" },
          { url: "https://dynamicore.io/en/credit-use-case", lang: "en-us" }
        ]}
        isUseCasesCredit={true}
      />
      <UseCasesPage/>
      <FooterSitemap />
    </Layout>
  )
}
